import React, { Component } from 'react';
import './RobotMessageComponent.css';
import PropTypes from 'prop-types';

export class RobotMessageComponent extends Component {
  static propTypes = {
    type: PropTypes.string.isRequired
  };
  static contextTypes = {
    t: PropTypes.func.isRequired
  };

  render() {
    const { t } = this.context;
    return (
      <div className="stateType">
        <div className={`logo ${this.props.type}`} />
        <div className="title">{t(`${this.props.type}.title`)}</div>
        <div className="description">{t(`${this.props.type}.description`)}</div>
      </div>
    );
  }
}

export default RobotMessageComponent;



// WEBPACK FOOTER //
// ./src/Components/RobotMessageComponent/RobotMessageComponent.js